import { render, staticRenderFns } from "./InfoPanel.vue?vue&type=template&id=3ea96dfa&scoped=true"
import script from "./InfoPanel.vue?vue&type=script&lang=ts"
export * from "./InfoPanel.vue?vue&type=script&lang=ts"
import style0 from "./InfoPanel.vue?vue&type=style&index=0&id=3ea96dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea96dfa",
  null
  
)

export default component.exports